import { ReactNode, useEffect } from "react";
import { useAtom, useAtomValue } from "jotai";

import { abilities } from "@libs/authorization";
import { ScreenLoading } from "@/blocks/ScreenLoading";
import { useCurrentStaff } from "@/hooks/useCurrentStaff";
import { userCurrentCampusId, userRoleAtom } from "@/stores/atoms";
import { useCurrentUserId } from "@/stores/authStore";

import { AbilityContext } from "./AbilityContext";

export const AuthorizationContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const staffUser = useCurrentStaff();
  const currentUserId = useCurrentUserId();

  const [userRoleFromAtom, setUserRoleAtom] = useAtom(userRoleAtom);
  const currentCampusId = useAtomValue(userCurrentCampusId);

  const userRole = userRoleFromAtom ?? staffUser?.role ?? "STUDENT";

  useEffect(() => {
    if (!userRoleFromAtom) {
      setUserRoleAtom(userRole);
    }
  }, [userRole, userRoleFromAtom, setUserRoleAtom]);

  if (!userRole) {
    return <ScreenLoading />;
  }

  return (
    <AbilityContext.Provider
      value={abilities({
        userId: currentUserId!,
        userRole,
        campusId: currentCampusId,
      })}>
      {children}
    </AbilityContext.Provider>
  );
};
